import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

const PolicyCTA = () => {
  const [showFloatingCTA, setShowFloatingCTA] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // 当滚动到页面底部50%时显示浮动CTA
      const scrollPercentage = scrollPosition / (documentHeight - windowHeight);
      setShowFloatingCTA(scrollPercentage > 0.5);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleTestClick = () => {
    window.REACT_APP_NAVIGATE?.('/test');
  };

  const handleCaseClick = () => {
    // 跳转到成功案例页面（待创建）
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {/* 主要行动引导区 */}
      <section className="py-20 bg-gradient-to-br from-primary to-primary-dark">
        <div className="max-w-[1440px] mx-auto px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-flex items-center gap-2 mb-6">
              <div className="w-3 h-3 bg-accent rotate-45"></div>
              <span className="text-accent text-sm font-semibold uppercase tracking-wider whitespace-nowrap">下一步行动</span>
            </div>

            <h2 className="text-4xl font-bold text-white mb-6">
              政策了解完毕，开始适配性评估
            </h2>

            <p className="text-xl text-white/80 mb-8 max-w-3xl mx-auto leading-relaxed">
              无需阅读政策原文，通过8个简单问题，3分钟判断您的业务是否适合1039模式
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
              <motion.button
                onClick={handleTestClick}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-accent text-primary font-bold px-8 py-4 rounded-xl hover:bg-accent/90 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer text-lg"
              >
                <i className="ri-play-circle-line mr-2"></i>
                测试我是否适合 1039
              </motion.button>

              <motion.button
                onClick={() => window.REACT_APP_NAVIGATE('/cases')}
                className="px-8 py-4 bg-white/10 text-white rounded-xl font-bold hover:bg-white/20 transition-colors border-2 border-white/30 whitespace-nowrap"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <i className="ri-file-list-3-line mr-2"></i>
                查看成功案例
              </motion.button>
            </div>

            {/* 信心保障 */}
            <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.2 }}
                className="text-center"
              >
                <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-accent text-2xl"></i>
                </div>
                <h3 className="text-white font-semibold mb-2">政策权威保障</h3>
                <p className="text-white/70 text-sm">国家级政策，海关监管，合规可靠</p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.3 }}
                className="text-center"
              >
                <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-time-line text-accent text-2xl"></i>
                </div>
                <h3 className="text-white font-semibold mb-2">快速评估</h3>
                <p className="text-white/70 text-sm">3分钟完成测试，即时获得结果</p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.4 }}
                className="text-center"
              >
                <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-customer-service-line text-accent text-2xl"></i>
                </div>
                <h3 className="text-white font-semibold mb-2">专业指导</h3>
                <p className="text-white/70 text-sm">白云天健专业团队全程服务</p>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* 浮动CTA按钮 */}
      {showFloatingCTA && (
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          className="fixed bottom-6 right-6 z-50"
        >
          <motion.button
            onClick={handleTestClick}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-accent text-primary font-bold px-6 py-3 rounded-full shadow-2xl hover:shadow-3xl transition-all whitespace-nowrap cursor-pointer border-2 border-white"
          >
            <i className="ri-play-circle-line mr-2"></i>
            开始测试
          </motion.button>
        </motion.div>
      )}
    </>
  );
};

export default PolicyCTA;